import { createSlice } from "@reduxjs/toolkit";
import type { TemplateModel } from "../../../models/template";

const initialState = {
  loading: false,
  data: null as TemplateModel | null,
  error: null,
};

const dataSlice = createSlice({
  name: "reorder-questions-model",
  initialState: initialState,
  reducers: {
    initReorderQuestionsModel: () => {
      return { ...initialState };
    },
    startReorderQuestionsModel: (state) => {
      state.loading = true;
    },
    successReorderQuestionsModel: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorReorderQuestionsModel: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initReorderQuestionsModel,
  startReorderQuestionsModel,
  successReorderQuestionsModel,
  errorReorderQuestionsModel,
} = dataSlice.actions;

export default dataSlice.reducer;
